module.exports = __webpack_public_path__ + "img/logo-dark.a83ad91c.svg";